import React from 'react';
import { Helmet } from "react-helmet"
import SongListTable from './SongListTable';
import CreatorArrTable from './CreatorArrTable';

interface Props {
    personData: any;
}

const CreatorDetail = ({personData}: Props) => {
    console.log('personData => ',personData)
    return (
        <div>
            <Helmet>
                <title>{'Rocksmith+ Community Charter Detail: '+personData.name}</title>
                <meta name='keywords' content={'community charter, '+personData.name}/>
                <meta property='og:title' content=''/>
                <meta property='og:image' content=''/>
                <meta property='og:url' content=''/>
                <meta property='og:description' content=''/>
                <meta name='twitter:title' content=''/>
                <meta name='twitter:description' content=''/>
                <meta name='twitter:image' content=''/>
            </Helmet>
            <table id='CreatorDetails' border={0}>
                <thead>
                    <tr><th colSpan={3}>Creator</th></tr>
                </thead>
                <tbody>
                    <tr><td>Name:</td><td width={'80%'} colSpan={2}>{personData.name}</td></tr>
                        <tr><td rowSpan={2}></td><td>Songs:</td><td width={'60%'}>{personData.songs ? personData.songs.length : null}</td></tr>
                        <tr><td>Arrangements:</td><td>{personData.arrangements ? personData.arrangements.length : null}</td></tr>
                            {/** Change rowspan to number of arr types + 1 */}
                    {/* <tr><td rowSpan={2}>Arrangement Types:</td><td></td></tr> 
                        <tr><td>Arr type</td><td>###</td></tr> */}
                    {/* <tr><td colSpan={3}><SongListTable data={personData.songs} myRegion='' searchRegion='' /></td></tr> */}
                    <tr><td colSpan={3} align='center'><CreatorArrTable arrData={personData.arrangements} /></td></tr>
                </tbody>
            </table>
        </div>
    )
}

export default CreatorDetail